import React, { Fragment, useContext, useState } from 'react';
import { Button, Divider, Ellipsis, List, Toast } from 'antd-mobile';
import { AddOutline } from 'antd-mobile-icons';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { matchesPermission } from '../utils/permission-helpers';
import UserSelfContext from '../utils/self-context';
import { createWorkOrderDefect } from '../api';
import AddDefectPopup from './AddDefectPopup';

const FlatDivider = styled(Divider)`
	margin: 0;
`;

const EmptyText = styled.span`
	color: var(--adm-color-weak);
`;

const ToastContent = styled.div`
	word-break: normal;
	text-align: center;
	width: 100%;
`;


function RelatedDefects(props) {
	const {
		defects,
		onChange,
		workOrderId,
		relatedTaskId,
		initialDescription
	} = props;
	const history = useHistory();
	const [saving, setSaving] = useState(false);
	const [showPopover, setShowPopover] = useState(false);
	const { userSelf } = useContext(UserSelfContext);

	async function handleSave(data) {
		setSaving(true);

		const payload = { ...data };

		payload.work_order_op_id = relatedTaskId || null;

		try {
			await createWorkOrderDefect(workOrderId, payload);
			setShowPopover(false);
			onChange();
		} catch (e) {
			Toast.show({
				icon: 'fail',
				content: <ToastContent>
					Unable to save Additional Work. Something went wrong.
				</ToastContent>
			});
		}
		setSaving(false);
	}

	return (
		<Fragment>
			<List header="Related Additional Work">
				{defects.map((defect) => {
					return (
						<List.Item
							key={defect.id}
							onClick={() => history.push(`/work-order/${defect.work_order_id}/defect/${defect.id}`)}
							clickable
						>
							<Ellipsis direction='end' rows={3} content={defect.description || '-'} />
						</List.Item>
					);
				})}
				{!matchesPermission(userSelf, 'add_defects') && !defects.length && <List.Item>
					<EmptyText>No Related Additional Work...</EmptyText>
				</List.Item>}
				{!!defects.length && <FlatDivider />}
				{matchesPermission(userSelf, 'add_defects') && <Button
					onClick={() => setShowPopover(true)}
					block
					color="primary"
					fill="none"
				>
					<AddOutline /> Add Additional Work
				</Button>}
			</List>
			<AddDefectPopup
				onSave={handleSave}
				saving={saving}
				initialValues={{ description: initialDescription }}
				visible={showPopover}
				onClose={() => setShowPopover(false)}
			/>
		</Fragment>
	);
}

export default RelatedDefects;
